module.exports = "<form [formGroup]=\"form\">\r\n  <div class=\"container-row margin-t-10 margin-b-10\">\r\n    <div class=\"row row-20\">\r\n      <label>Start Index:</label>\r\n      <input type=\"number\" formControlName=\"startIndex\"/>\r\n    </div>\r\n    <div class=\"row row-20 margin-l-30\">\r\n      <label>Length:</label>\r\n      <input type=\"number\" formControlName=\"length\"/>\r\n    </div>\r\n  </div>\r\n</form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/import-template/component/substring/substring.component.html
// module id = 2458
// module chunks = 66